import { render, staticRenderFns } from "./SummaryOfVolumesConsumed.vue?vue&type=template&id=d8ee6392"
import script from "./SummaryOfVolumesConsumed.vue?vue&type=script&lang=js"
export * from "./SummaryOfVolumesConsumed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports